import { atom, selector, useRecoilState } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

const ZOOM_MODE_X = "x";
const ZOOM_MODE_Y = "y";
const ZOOM_MODE_XY = "xy";
const ZOOM_MODE = [
  ZOOM_MODE_X,
  ZOOM_MODE_Y,
  ZOOM_MODE_XY
];

const csZoomState = atom({
  key: 'csZoomState',
  default: selector({
    key: 'csZoomStateSelector',
    get: () => {
      return getCustomerSettings('csConfig.zoomMode');
    }
  })
});

export const useCsZoomState = () => {
  const [zoomMode, setZoomMode] = useRecoilState(csZoomState);
  const isXZoomEnable = zoomMode === ZOOM_MODE_X || zoomMode === ZOOM_MODE_XY;
  const isYZoomEnable = zoomMode === ZOOM_MODE_Y || zoomMode === ZOOM_MODE_XY;

  const toggleZoomMode = () => {
    const mode = ZOOM_MODE[(ZOOM_MODE.findIndex(item => item === zoomMode)+1)%ZOOM_MODE.length];
    setZoomMode(mode);
  };

  return {
    isXZoomEnable,
    isYZoomEnable,
    toggleZoomMode
  }
}
